<template>
    <div class="status-avatar" :class="[status, margin ? '' : 'no-margin']" :style="statusStyles">
        <progressive-img
            :key="key"
            class="avatar"
            :src="avatarUrl"
            :fallback="prefix + '/assets/fallbacks/avatar.png'"
            no-ratio
            :style="'width:' + size + 'px; height:' + size + 'px;'"
        />
    </div>
</template>

<script>

export default {
    name: "ClientAvatar",
    props: {
        dbid: [Number,String],
        size: {
            type: Number,
            default: 40
        },
        status: {
            type: String,
            default: ''
        },
        margin: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            key: 0,
            time: Date.now()
        }
    },
    updated() {
        this.$nextTick(function () {
            if (Date.now() - this.time > 500) {
                this.key++;
                this.time = Date.now();
            }
        })
    },
    computed: {
        avatarUrl() {
            return this.prefix + '/assets/avatars/' + this.dbid + '.png';
        },
        statusStyles() {
            if (this.status != '') {
                return 'width: '+(this.size+5)+'px; height: '+(this.size+5)+'px';
            } else
                return ''
        },
        prefix() {
            return process.env.NODE_ENV !== 'development' ? '' : 'http://51.75.37.170:3000';
        }
    }
}
</script>

<style>
    .avatar {
        position: relative;
        border-radius: 50%;
        -moz-box-shadow: 0 2px 2px rgba(0, 0, 0, 0.3);
        -webkit-box-shadow: 0 2px 2px rgba(0, 0, 0, 0.3);
        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.3);
        margin-right: 6px;
    }

    .avatar img {
        width: auto !important;
        height: 100% !important;
        transform: translate(-50%, -50%);
        top: 50% !important;
        left: 50% !important;
    }

    .status-avatar {
        border-radius: 50%;
    }

    .status-avatar.online {
         border: 2px solid green;
        margin-right: 5px;
     }

    .status-avatar.offline {
         border: 2px solid red;
        margin-right: 5px;
     }

    .status-avatar.away {
         border: 2px solid orange;
        margin-right: 5px;
     }

    .no-margin {
        margin: 0!important;
    }

    .no-margin .avatar {
        margin: 0!important;
    }
</style>